export function isScreenPlacementWithName(value: string) {
  return value.match(/^Screen:/)
}
